<form [formGroup]="form" class="container">
  <section class="header">
    <mat-form-field appearance="outline" class="header__facility">
      <mat-label>Facility</mat-label>
      <mat-select matInput placeholder="Facility" formControlName="facilityId">
        <mat-option *ngFor="let option of facilities" [value]="option.id">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ifb-card class="header__card-container">
      <ifc-simple-horizontal-list-widget
        title="Totals"
        [listItems]="totalsListItems"
        [config]="totalsWidgetConfig"
      ></ifc-simple-horizontal-list-widget>
    </ifb-card>
  </section>
  <section class="filters-toolbar">
    <ifc-filters-active-list
      class="layout margin-sm"
      [filters]="activeFilters"
      (filterRemoved)="activeFilterRemoved($event)"
    ></ifc-filters-active-list>
    <div class="layout padding-right-md">
      <button mat-icon-button (click)="filterDialog()" matTooltip="Filter">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </section>
  <ifc-app-scroll-container>
    <div class="table-container">
      <div class="message-box info" *ngIf="!accountPledgeQueryResult?.totalCount">
        <mat-icon class="icon">info</mat-icon>
        <span>No data found</span>
      </div>
      <table
        *ngIf="!!accountPledgeQueryResult?.totalCount"
        mat-table
        matSort
        [dataSource]="accountPledgeQueryResult.values"
        (matSortChange)="sortData()"
        class="table"
      >
        <ng-container matColumnDef="selected">
          <th mat-header-cell *matHeaderCellDef class="table__header"></th>
          <td mat-cell *matCellDef="let row" class="table__cell table__cell--checkbox">
            <mat-checkbox
              color="primary"
              [checked]="selectedLoans | arraySome: row.id : 'id'"
              (change)="onChange($event, row)"
            ></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="alligatorDataIcon">
          <th mat-header-cell *matHeaderCellDef class="table__header"></th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            <div [ngClass]="row | alligatorDataClass">
              <mat-icon matTooltip="{{ row | alligatorDataTooltip }}" [inline]="true" class="small">
                {{ row | alligatorDataIcon }}
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="loanNumber">
          <th mat-header-cell *matHeaderCellDef class="table__header" mat-sort-header="loanNumber">Loan number</th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            {{ row.loanNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="entityName">
          <th mat-header-cell *matHeaderCellDef class="table__header" mat-sort-header="entityName">
            Legal entity name
          </th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            {{ row.entityName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="table__header" mat-sort-header="status">Status</th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            <span *ngIf="row.status === LoanStatus.Open">Open</span>
            <ifb-account-status-icon-chip
              *ngIf="row.status !== LoanStatus.Open && row.status !== undefined"
              [status]="row.status"
            ></ifb-account-status-icon-chip>
          </td>
        </ng-container>

        <ng-container matColumnDef="productCode">
          <th mat-header-cell *matHeaderCellDef class="table__header" mat-sort-header="productCode">Product type</th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            {{ row.productCode | productCodeLabel }}
          </td>
        </ng-container>

        <ng-container matColumnDef="facilityName">
          <th mat-header-cell *matHeaderCellDef class="table__header" mat-sort-header="facilityName">Facility</th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            {{ row.facilityName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="caseName">
          <th mat-header-cell *matHeaderCellDef class="table__header" mat-sort-header="caseName">Case name</th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            {{ row.caseName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="offerAmount">
          <th mat-header-cell *matHeaderCellDef class="table__header" mat-sort-header="offerAmount">Offer amount</th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            {{ row.offerAmount | currency }}
          </td>
        </ng-container>

        <ng-container matColumnDef="availableFunds">
          <th mat-header-cell *matHeaderCellDef class="table__header" mat-sort-header="availableFunds">
            Available funds
          </th>
          <td mat-cell *matCellDef="let row" class="table__cell">
            {{ row.availableFunds | currency }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="table-header"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hoverable-row"></tr>
      </table>
    </div>
  </ifc-app-scroll-container>
  <mat-paginator
    [hidden]="accountPledgeQueryResult?.totalCount > 10"
    showFirstLastButtons
    [length]="accountPledgeQueryResult?.totalCount"
    [pageSizeOptions]="[10, 20, 50]"
    (page)="setPage()"
  ></mat-paginator>
</form>
